module.exports = __webpack_public_path__ + "static/Process_1-b1aca32eda779507e6f92f4239ee1883.jpg";